import { render } from "./ListeCategorieClientPage.vue?vue&type=template&id=79df2605&ts=true"
import script from "./ListeCategorieClientPage.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__